import React from "react";
import { DisplayTextRow } from "../DisplayTextRow";
import { ValueDisplay } from "../../ValueDisplay";
import { FieldDisplayRendererProps } from "./types";

export const ObjectDisplayRenderer = ({
  field,
  value,
  t,
}: FieldDisplayRendererProps) => {
  return (
    <DisplayTextRow label={t(field.label)}>
      <ValueDisplay field={field} value={value} />
    </DisplayTextRow>
  );
};
